import i18n from '@/i18n'
import { isObjEmpty } from '@/utils/utils'

export default {
    methods: {
        getTranslatedText(text: string, xargs: any = {}) {
            if (!text) {
                return
            }
            const rsText = text.toLowerCase()
            let translatedText: any = i18n.t(rsText.toString())

            if (!isObjEmpty(xargs)) {
                for (const key in xargs) {
                    translatedText = translatedText.replace('[' + key + ']', xargs[key])
                }
            }

            return translatedText
        },
    },
}
